// @ts-nocheck
import {Column} from 'react-table'
import UserInfoCell from './UserInfoCell'
import {UserCustomHeader} from './UserCustomHeader'
import {ParticipationsCell} from './ParticipationsCell'

import {User} from '../../core/_models'

const usersColumns: ReadonlyArray<Column<User>> = [
  {
    Header: (props) => <UserCustomHeader tableProps={props} title='Username' className='min-w-125px' />,
    id: 'username',
    Cell: ({...props}) => <UserInfoCell item={props.data[props.row.index]} />,
  },
  {
    Header: (props) => <UserCustomHeader tableProps={props} title='Participations' className='min-w-125px' />,
    id: 'participations',
    Cell: ({...props}) => <ParticipationsCell item={props.data[props.row.index]} />,
  },
]

export {usersColumns}
